var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab3",staticStyle:{"height":"100vh"}},[_c('ul',{staticClass:"handle_list"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.handleMenuClick(item)}}},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_c('p',[_vm._v(_vm._s(item.menuName))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }